import { useIntl } from 'react-intl';
import { Filter, Maximize2, RefreshCw, TimerReset } from 'lucide-react';
import { Input } from 'reactstrap';

import Button from 'src/componentes/button';
import { SophieIcon } from 'src/componentes/icons';
import Tooltip from 'src/componentes/tooltip';

// Intervalos de auto-refresh em minutos (0 = desligado).
const AUTO_REFRESH_OPTIONS_MINUTOS = [0, 5, 15, 30, 60];

function DashboardHeaderActions({
  isLoading,
  onOpenFiltro,
  temFiltros = false,
  autoRefreshMinutos,
  onChangeAutoRefresh,
  onRefresh,
  onMaximizar,
  onGerarInsights,
  gerarInsightsTooltip,
}) {
  const intl = useIntl();

  return (
    <div className="d-flex align-items-stretch flex-wrap" style={{ gap: 8 }}>
      {(onGerarInsights || gerarInsightsTooltip) && (
        <Tooltip text={gerarInsightsTooltip} placement="top">
          <span
            style={{
              cursor: onGerarInsights ? 'pointer' : 'not-allowed',
              display: 'inline-flex',
            }}
          >
            <Button
              disabled={!onGerarInsights || isLoading}
              leftIcon={<SophieIcon color="#fff" size={15} />}
              onClick={onGerarInsights}
              size="sm"
              style={onGerarInsights ? undefined : { pointerEvents: 'none' }}
            >
              {intl.formatMessage({ id: 'gerarResumo' })}
            </Button>
          </span>
        </Tooltip>
      )}
      {onOpenFiltro && (
        <Button
          color={temFiltros ? 'primary' : 'outline-primary'}
          leftIcon={Filter}
          onClick={onOpenFiltro}
          size="sm"
        >
          {intl.formatMessage({ id: 'label.filtrar' })}
        </Button>
      )}
      <div className="d-flex align-items-center" style={{ gap: 6 }}>
        <TimerReset size={15} color="#667085" />
        <Input
          aria-label={intl.formatMessage({ id: 'labelAtualizacaoAutomatica' })}
          bsSize="sm"
          onChange={(event) => onChangeAutoRefresh(Number(event.target.value))}
          style={{ width: 'auto', height: '100%' }}
          title={intl.formatMessage({ id: 'labelAtualizacaoAutomatica' })}
          type="select"
          value={autoRefreshMinutos}
        >
          {AUTO_REFRESH_OPTIONS_MINUTOS.map((minutos) => (
            <option key={minutos} value={minutos}>
              {minutos === 0
                ? intl.formatMessage({ id: 'labelAutoRefreshDesligado' })
                : intl.formatMessage(
                    { id: 'labelAutoRefreshACadaMinutos' },
                    { minutos }
                  )}
            </option>
          ))}
        </Input>
      </div>
      <Button
        color="outline-primary"
        disabled={isLoading}
        leftIcon={RefreshCw}
        onClick={onRefresh}
        size="sm"
      >
        {intl.formatMessage({ id: 'label.atualizar' })}
      </Button>
      {onMaximizar && (
        <Button
          color="outline-primary"
          onClick={onMaximizar}
          size="sm"
          title={intl.formatMessage({ id: 'labelMaximizar' })}
        >
          <span
            style={{ alignItems: 'center', display: 'inline-flex', height: 24 }}
          >
            <Maximize2 size={16} />
          </span>
        </Button>
      )}
    </div>
  );
}

export default DashboardHeaderActions;
